import { Tenant, User } from "@bluefalcon/users-management-client-fetch";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { tenantsService } from "../../services";
import { Box, Heading, Flex, Text } from "@chakra-ui/react";
import { LoadingSpinner } from "@bluefalcon/components-package";
import { UsersTable } from "../../components/users-table/users-table.comp";
import { MembershipsTable } from "../../components/memberships-table/memberships-table.comp";


export function TenantDetails() {
    const { tenantId } = useParams();
    const navigate = useNavigate();
    const [tenant, setTenant] = useState<Tenant>();
    const [isLoading, setIsLoading] = useState(false);

    const getTenantById = async () => {
        if (!tenantId) {
            navigate('/');
            return;
        }
        try {
            setIsLoading(true);
            const foundTenant = await tenantsService.getTenantById(tenantId);
            setTenant(foundTenant);
        } catch (e: any) {
            navigate('/');
        } finally {
            setIsLoading(false);
        }

    };

    const onChangeMemberships = () => {
        getTenantById();
    };

    useEffect(() => {
        getTenantById();
    }, []);

    if (isLoading) {
        return <LoadingSpinner />
    }

    if (!tenant) {
        return <div></div>
    }

    return (
        <Box p={4}>
            <Flex>
                <Heading as={'h1'}>{tenant.name}</Heading>
            </Flex>
            <Box
                mt={5}
                borderWidth="1px"
                borderRadius="lg"
                p={6}
                boxShadow="md"
                mb={6}
                bg="white"
            >
                <Flex mb={4}>
                    <Text fontWeight="bold" mr={2}>
                        ID:
                    </Text>
                    <Text>{tenant.id}</Text>
                </Flex>
                <Flex mb={4}>
                    <Text fontWeight="bold" mr={2}>
                        Name:
                    </Text>
                    <Text>{tenant.name}</Text>
                </Flex>
                <Flex mb={4}>
                    <Text fontWeight="bold" mr={2}>
                        Email:
                    </Text>
                    <Text>{tenant.email || 'None'}</Text>
                </Flex>
            </Box>
            <Box mt={10}>
                <Heading size={'md'}>Users</Heading>
                <UsersTable showAddButton={true} tenantId={tenant.id} />
            </Box>
            <Box mt={10}>
                <Heading size={'md'}>Memberships</Heading>
                <MembershipsTable onChange={onChangeMemberships} tenant={tenant} memberships={tenant.userMemberships ?? []} />
            </Box>
        </Box>
    );
}
